import {observer} from "mobx-react-lite";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";

import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {Tag} from "primereact/tag";

import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";

import Select from "../../../ui/Select";
import Btn from "../../../ui/Btn";
import PageLayout from "../../PageLayout";
import NumericPagination from "../../NumericPagination";

import "./../../../common/billing.css";


const BillingInfo = () => {

    const navigate = useNavigate();
    const query = clubStore.billing.query;

    useEffect(() => {

        const now = new Date();

        const {
            first,
            last,
        } = clubStore.getMonthRange(
            now.getFullYear(),
            now.getMonth()
        );

        /*
         * BillingQuery используется также на страницах
         * отдельных Billing.
         *
         * Поэтому при входе в список BillingGroup
         * полностью сбрасываем фильтры Billing.
         */
        query.setProperty(
            "page_number",
            1
        );
        query.setProperty(
            "company_user_id",
            0
        );
        query.setProperty(
            "billing_type_id",
            0
        );
        query.setProperty(
            "object_id",
            0
        );
        query.setProperty(
            "payment_method",
            ""
        );

        query.setProperty(
            "is_paid",
            null
        );

        query.setProperty(
            "is_approved",
            null
        );

        query.setProperty(
            "title",
            ""
        );

        query.setProperty(
            "date_from",
            first
        );

        query.setProperty(
            "date_to",
            last
        );

        query.setProperty(
            "total",
            0
        );

        query.setProperty(
            "page_count",
            0
        );


        // Не показываем данные предыдущей страницы
        // пока загружаются BillingGroup.

        clubStore.billing.setProperty(
            "items",
            []
        );


        if (
            clubStore.billing_types.length === 0
        ) {
            clubStore.getBillingTypes();
        }


        clubStore.billing.search();

    }, []);


    const months =
        clubStore.getLastThreeMonths();


    const PaymentStatus = [
        {
            id: true,
            name: appStore.tr.paid,
        },
        {
            id: false,
            name: appStore.tr.unpaid,
        },
    ];


    const ApprovalStatus = [
        {
            id: true,
            name: appStore.tr.approved,
        },
        {
            id: false,
            name: appStore.tr.not_approved,
        },
    ];


    const PaymentMethod = [
        {
            id: "cash",
            name: appStore.tr.cash,
        },
        {
            id: "transfer",
            name: appStore.tr.transfer,
        },
    ];


    const search = () => {

        query.setProperty(
            "page_number",
            1
        );

        /*
         * Защита от случайно оставшегося
         * company_user_id из MemberBillings.
         */

        query.setProperty(
            "company_user_id",
            0
        );

        clubStore.billing.search();
    };


    const handleSelectMonth = (
        year,
        monthIndex
    ) => {

        const {
            first,
            last,
        } = clubStore.getMonthRange(
            year,
            monthIndex
        );


        query.setProperty(
            "date_from",
            first
        );

        query.setProperty(
            "date_to",
            last
        );

        query.setProperty(
            "page_number",
            1
        );

        query.setProperty(
            "company_user_id",
            0
        );


        clubStore.billing.search();
    };


    const BillingGroupItem = ({
        group,
    }) => {

        const isFullyPaid =
            group.billing_count > 0 &&
            group.unpaid_count === 0;


        return (
            <div className="billing-card">

                <div className="billing-top">

                    <div className="billing-main">

                        <div className="billing-title">
                            {group.name}
                        </div>


                        <div className="billing-sub">

                            {
                                group.billing_type
                                    ?.name
                            }

                            {
                                group.object?.name && (
                                    <span>
                                        , {group.object.name}
                                    </span>
                                )
                            }

                        </div>


                        <div className="flex flex-wrap gap-2 mt-2">

                            <Tag severity="info">

                                {
                                    appStore.tr.members ||
                                    "Участники"
                                }:{" "}

                                {
                                    group.billing_count
                                }

                            </Tag>


                            <Tag severity="success">

                                {
                                    appStore.tr.paid
                                }:{" "}

                                {
                                    group.paid_count
                                }

                            </Tag>


                            {
                                group.unpaid_count > 0 && (
                                    <Tag severity="danger">

                                        {
                                            appStore.tr.unpaid
                                        }:{" "}

                                        {
                                            group.unpaid_count
                                        }

                                    </Tag>
                                )
                            }

                        </div>

                    </div>


                    <div className="billing-side">

                        <div className="billing-amount">
                            {group.total_amount}
                        </div>


                        <div className="billing-status">

                            <Tag
                                severity={
                                    isFullyPaid
                                        ? "success"
                                        : "warning"
                                }
                            >

                                {
                                    isFullyPaid
                                        ? appStore.tr.paid
                                        : `${appStore.tr.unpaid}: ${group.debt_amount}`
                                }

                            </Tag>

                        </div>

                    </div>

                </div>


                <div className="billing-sub mt-2">

                    {group.period_from}

                    {
                        group.period_to &&
                        group.period_to !==
                        group.period_from && (
                            <span>
                                {" — "}
                                {group.period_to}
                            </span>
                        )
                    }

                </div>


                <div className="billing-actions">

                    <Btn
                        icon="pi pi-eye"
                        severity="success"
                        outlined
                        onClick={() =>
                            navigate(
                                `/manager/billing/group/${group.id}`
                            )
                        }
                    />

                </div>

            </div>
        );
    };


    return (
        <PageLayout
            header={
                <div className="flex justify-content-between align-items-center">
                    <h3 className="m-0">
                        {appStore.tr.billing}
                        {" "}
                        ({query.total})
                    </h3>
                    <Btn
                        icon="pi pi-plus"
                        severity="success"
                        label={appStore.tr.add}
                        size="small"
                        onClick={() =>
                            navigate(
                                "/manager/billing/create"
                            )
                        }
                    />
                </div>
            }
            filters={
                <div className="grid align-items-center">
                    {/* MONTHS */}
                    <div className="col-12 flex flex-wrap gap-2">
                        {months.map(
                            (
                                month,
                                index
                            ) => (
                                <Button
                                    key={index}
                                    label={
                                        appStore.tr[
                                            month.monthName
                                                .toLowerCase()
                                        ]
                                    }
                                    className="p-button-sm p-button-secondary"
                                    onClick={() =>
                                        handleSelectMonth(
                                            month.year,
                                            month.monthIndex
                                        )
                                    }
                                />
                            )
                        )}
                    </div>
                    {/* DATE FROM */}
                    <div className="col-6 md:col-2">
                        <Calendar
                            className="w-full"
                            inputStyle={{height: '40px'}}
                            value={query.date_from}
                            maxDate={query.date_to}
                            onChange={(event) =>
                                query.setProperty(
                                    "date_from",
                                    event.value
                                )
                            }
                            dateFormat="dd.mm.yy"
                        />

                    </div>
                    {/* DATE TO */}
                    <div className="col-6 md:col-2">
                        <Calendar
                            className="w-full"
                            inputStyle={{height: '40px'}}
                            value={query.date_to}
                            minDate={query.date_from}
                            onChange={(event) =>
                                query.setProperty(
                                    "date_to",
                                    event.value
                                )
                            }
                            dateFormat="dd.mm.yy"
                        />
                    </div>
                    {/* BILLING TYPE */}
                    <div className="col-8 md:col-2">
                        <Select
                            label={
                                appStore.tr.billing_type
                            }
                            store={query}
                            prop="billing_type_id"
                            options={
                                clubStore.billing_types
                            }
                            style={{height: '40px'}}
                            for_search
                        />

                    </div>
                    {/* SEARCH */}
                    <div className="col-4 md:col-1 flex align-items-end">
                        <Btn
                            icon="pi pi-search"
                            severity="info"
                            label={appStore.tr.search}
                            style={{height: '40px'}}
                            onClick={search}
                        />
                    </div>
                </div>
            }
            pagination={
                <NumericPagination
                    query={query}
                    onPageChange={(page) => {
                        query.setProperty(
                            "page_number",
                            page
                        );
                        query.setProperty(
                            "company_user_id",
                            0
                        );
                        clubStore.billing.search();
                    }}
                />
            }
        >
            {
                clubStore.billing.items.length === 0 && (
                    <div className="flex py-2 justify-content-center">
                        {appStore.tr.not_found}
                    </div>
                )
            }
            {
                clubStore.billing.items.map(
                    (group) => (
                        <BillingGroupItem
                            key={group.id}
                            group={group}
                        />
                    )
                )
            }
        </PageLayout>
    );
};


export default observer(BillingInfo);